module.exports = __webpack_public_path__ + "static/Siva-a32c4c9a86ddc89d9f933ce7d6047136.jpg";